module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-components/nav-profile/nav-profile.component.css
// module id = ./src/app/ui-components/nav-profile/nav-profile.component.css
// module chunks = main